import { store, StoreState } from 'src/store/configureStore'
import { ToolsImplementationsType } from '../AiAssistantHelper'
import { responseGenerator } from '../apiCallHelper'
import { findVersionFromModel, performFuzzySearch } from '../convertHelper'
import { Alert, Flex, Table, Tag, Typography } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import useTranslate from 'src/utils/useTranslate'
import { useCallback, useMemo } from 'react'
import { modelsConfigAiAssistantRequest } from 'src/store/actions/formulate';
import { StyledButton } from 'src/styled_components/StyledButton'
import { inverseConfigRequest } from 'src/store/actions/inverseModel'
import { AsyncStates } from 'src/constants'
import { useHistory } from 'react-router-dom'
import { useValue } from 'src/utils/useValue'
import { clearInverseData, setInverseData } from 'src/store/actions/aiAssist'

export const inversePredictionToolsSchema = () => {
  return [
    {
      type: 'function',
      function: {
        name: 'prepare_inverse_prediction_data',
        description:
          'Unrelated with get_forward_inverse_predictions, Pepares an inverse prediction task data (we dont not perform forward prediction at all, it is not supported) based on the user input, different from finding or listing forward/inverse data which is done by get_forward_inverse_predictions, always take human-in-the-loop approach, perform the tool call only after getting all the required parameters from the user, do not assume any parameters, always ask the user to specify the parameters and confirm with user before making a tool call, dont ask for additional properties',
        parameters: {
          type: 'object',
          properties: {
            is_multistage: {
              type: 'boolean'
            },
            start_stage: {
              type: 'string',
              description: 'Start stage of the inverse prediction task, required only if is_multistage is true otheriwse chose default value',
              default: 'Default'
            },
            end_stage: {
              type: 'string',
              description: 'End stage of the inverse prediction task, required only if is_multistage is true otheriwse chose default value',
              default: 'Default'
            },
            model_name: {
              type: 'string',
              description: 'Name of the model to use for inverse prediction'
            },
            objectives: {
              type: 'array',
              items: {
                type: 'object',
                description: 'List of objectives for the inverse prediction task',
                properties: {
                  objective: {
                    type: 'string',
                    description: 'Objective / property to optimize for'
                  },
                  objective_value_type: {
                    type: 'string',
                    enum: ['numerical', 'categorical'],
                    description:
                      'Type of the objective, either numerical or categorical, only ask when user mentions list of values like A, B, C then it is categorical, else dont ask and choose numerical'
                  },
                  optimization_type: {
                    type: 'string',
                    enum: ['minimize', 'maximize', 'range'],
                    description: 'Type of the objective, either minimize or maximize or range, for categorical objectives, always use range'
                  },
                  min: {
                    type: 'number',
                    description: 'Minimum value for the objective, required if type is range otherwise not',
                    default: undefined
                  },
                  max: {
                    type: 'number',
                    description: 'Maximum value for the objective, required if type is range otherwise not',
                    default: undefined
                  },
                  values: {
                    type: 'array',
                    items: {
                      type: 'string',
                      description: 'Values for the categorical constraint'
                    },
                    description: 'Values for the categorical constraint, required if objective_value_type is categorical'
                  },
                  priority: {
                    type: 'integer',
                    description: 'Priority of the objective, lower value means higher priority, categorical objective_value_type dont have priority, ask optionally',
                    default: 1
                  }
                },
                required: ['objective', 'objective_value_type', 'optimization_type', 'priority'],
                additionalProperties: false
              },
              description: 'List of objectives to optimize for'
            }
            // category_constraints: {
            //   type: 'array',
            //   items: {
            //     type: 'array',
            //     items: {
            //       type: 'object',
            //       properties: {
            //         category: {
            //           type: 'string',
            //           description: 'Category name for the constraint'
            //         },
            //         category_type: {
            //           type: 'string',
            //           enum: ['ingredients', 'processing'],
            //           description: 'Type of the category, either ingredients or processing, always ask the user to specify the type, dont assume it'
            //         },
            //         exclusion_mode: {
            //           type: 'string',
            //           enum: ['can_include', 'must_include', 'exclude'],
            //           description:
            //             'Exclusion mode for the constraint, either can_include or must_include or exclude, if exclude then have parameter_constraints as [] even if provided by user as excluded category cannot have parameters '
            //         },
            //         min_count: {
            //           type: 'integer',
            //           description:
            //             'Minimum count of the category to include in the constraint, value will be 1 if exclusion_mode is must_include, 0 if exclusion_mode is can_include, use this if user specifies just min or minimum',
            //           default: null
            //         },
            //         max_count: {
            //           type: 'integer',
            //           description:
            //             'Maximum count of the category to include in the constraint, null if no maximum count is specified, use this if user specifies just max or maximum',
            //           default: null
            //         },
            //         min_quantity: {
            //           type: 'number',
            //           description: 'Minimum quantity of the category to include in the constraint, null if no maximum quantity is specified',
            //           default: 0
            //         },
            //         max_quantity: {
            //           type: 'number',
            //           description: 'Maximum quantity of the category to include in the constraint, null if no maximum quantity is specified',
            //           default: null
            //         },
            //         parameter_constraints: {
            //           type: 'array',
            //           items: {
            //             type: 'object',
            //             properties: {
            //               parameter: {
            //                 type: 'string',
            //                 description: 'parameter name for the constraint'
            //               },
            //               exclusion_mode: {
            //                 type: 'string',
            //                 enum: ['can_include', 'must_include', 'exclude'],
            //                 description:
            //                   'Exclusion mode for the constraint, either can_include or must_include or exclude, always ask the user to specify the exclusion mode, dont assume it'
            //               },
            //               value_type: {
            //                 type: 'string',
            //                 enum: ['numerical','categorical'],
            //                 description:
            //                   'Type of the values, either categorical or numerical, if values are provided in A, B, C / A or B or C format then categorical else numerical'
            //               },
            //               values: {
            //                 type: 'array',
            //                 items: {
            //                   type: 'string',
            //                   description: 'Values for the parameter constraint'
            //                 },
            //                 description: 'Values for the parameter constraint, required if type is categorical'
            //               },
            //               min: {
            //                 type: 'number',
            //                 description: 'Minimum value for the constraint, required if type is numerical'
            //               },
            //               max: {
            //                 type: 'number',
            //                 description: 'Maximum value for the constraint, required if type is numerical'
            //               }
            //             },
            //             required: ['parameter', 'exclusion_mode', 'value_type'],
            //             additionalProperties: false
            //           },
            //           description:
            //             'List of parameter constraints, always ask user to specify parameter constraints per category, before going ahead with the inverse prediction, dont assume it as []'
            //         }
            //       },
            //       required: [
            //         'category',
            //         'category_type',
            //         'exclusion_mode',
            //         'min_count',
            //         'max_count',
            //         'min_quantity',
            //         'max_quantity',
            //         'parameter_constraints'
            //       ],
            //       additionalProperties: false
            //     },
            //     description:
            //       'List of category constraints, for each stage between start_stage and end_stage there should be a category_constraint, default to [] if not provided'
            //   },
            //   description: 'Stage-wise list of category constraints to apply'
            // }
          },
          required: ['model_name', 'end_stage', 'start_stage', 'is_multistage', 'objectives'],
          additionalProperties: false
        }
      }
    }
  ]
}

export const inversePredictionToolsImplementation: () => ToolsImplementationsType = () => {
  return {
    prepare_inverse_prediction_data: async (args: Record<string, any>) => {
      const {
        model_name,
        objectives: intermediate_objectives,
        // category_constraints,
        is_multistage,
        start_stage,
        end_stage
      } = args

      const findStageDetails = () => {
        const modelConfigData = store.getState().formulate.modelConfigDataAiAssistant
        const allStages = modelConfigData?.[0]?.all_stages ?? []
        
        let startStage = start_stage
          ? performFuzzySearch({
              data: allStages?.map((stage: string) => ({
                stage
              })),
              searchTerm: start_stage,
              searchKey: 'stage',
              outputKey: 'stage'
            })
          : is_multistage
          ? allStages[0]
          : 'Default'

        let endStage = end_stage
          ? performFuzzySearch({
              data: allStages?.map((stage: string) => ({
                stage
              })),
              searchTerm: end_stage,
              searchKey: 'stage',
              outputKey: 'stage'
            })
          : is_multistage
          ? allStages[0]
          : 'Default'

        if (!endStage) {
          endStage = modelConfigData?.[0]?.all_stages?.slice(-1)?.[0] || startStage
        }

        if (!startStage) {
          startStage = modelConfigData?.[0]?.all_stages?.[0]
        }

        const startStageIndex = modelConfigData?.[0]?.all_stages?.findIndex((stage: string) => stage === startStage)
        const endStageIndex = modelConfigData?.[0]?.all_stages?.findIndex((stage: string) => stage === endStage)

        return {
          startStage,
          endStage,
          startStageIndex,
          endStageIndex
        }
      }

      const version = findVersionFromModel(model_name)

      store.dispatch(
        modelsConfigAiAssistantRequest({
          version,
          isMultiStage: is_multistage
        })
      )

      store.dispatch(inverseConfigRequest())

      return responseGenerator({
        data: {
          intermediate_objectives,
          // category_constraints,
          is_multistage
        },
        StatefulNodeComponent: (props: any) => {
          const { data } = props
          const {
            intermediate_objectives,
            // category_constraints,
            is_multistage
          } = data

          const { push } = useHistory()

          const [t] = useTranslate()
          const dispatch = useDispatch()
          const { getValue, convertValue } = useValue()

          const modelConfigData = useSelector((state: StoreState) => state.formulate.modelConfigDataAiAssistant)
          const newInverseModel = useSelector((state: StoreState) => state.newInverseModel)

          // eslint-disable-next-line react-hooks/exhaustive-deps
          const priority_list: Record<string, number> = {}

          const objectives = useMemo(() => {
            return intermediate_objectives?.reduce((acc: any, obj: any) => {
              const { objective_value_type, optimization_type, min, max, values, objective, priority } = obj

              const { endStageIndex } = findStageDetails()

              const modelConfigDataCurrentStage = modelConfigData[endStageIndex] || {}

              if (modelConfigData.length && !modelConfigData?.[endStageIndex]) {
                dispatch(
                  modelsConfigAiAssistantRequest({
                    version,
                    isMultiStage: is_multistage,
                    stage_name: modelConfigData?.[0]?.all_stages?.[endStageIndex]
                  })
                )
              }

              const objectiveTypeMapping = Object.entries(
                (modelConfigDataCurrentStage?.output_range_optimal ?? modelConfigDataCurrentStage?.properties) || {}
              )
                .map(([key, value]) => ({
                  key,
                  type: !Array.isArray(value) ? 'numerical' : 'categorical',
                  value
                }))
                .reduce((acc: any, { key, value, type }: any) => {
                  acc[key] = {
                    type,
                    value
                  }
                  return acc
                }, {})

              const properties = modelConfigDataCurrentStage?.display_names?.properties || {}




              const propertyId = performFuzzySearch({
                data: Object.entries(properties)
                  .map(([identifier, name]: any) => ({ name, identifier }))
                  ?.filter((item: any) => (modelConfigDataCurrentStage?.output_properties || [])?.includes(item.identifier)),
                searchTerm: objective,
                searchKey: 'name',
                outputKey: 'identifier',
                threshold: 0.2
              })

              if (!propertyId) {
                return acc
              }

              if (objectiveTypeMapping[propertyId]?.type !== objective_value_type) {
                return acc
              }

              if (objectiveTypeMapping[propertyId]?.type === 'categorical' && !values) {
                return acc
              }

              if (objective_value_type === 'categorical' && !values) {
                return acc
              }

              if (objective_value_type === 'categorical') {
                const updatedValues = (Array.isArray(values) ? values : [values]).map((val: string) => {
                  return performFuzzySearch({
                    data: objectiveTypeMapping[propertyId]?.value.map((res: string) => ({ res })),
                    searchTerm: val,
                    searchKey: 'res',
                    outputKey: 'res',
                    threshold: 0.7
                  })
                })
                if (updatedValues.length === 0) {
                  return acc
                }
                acc[propertyId] = {
                  parameter: propertyId,
                  modelType: 'range',
                  output_range_optimal: `${(modelConfigDataCurrentStage?.output_range_optimal ?? modelConfigDataCurrentStage?.properties)?.[
                    propertyId
                  ]?.join(', ')}`,
                  val: updatedValues,
                  checked: false
                }
              } else if (objective_value_type === 'numerical') {
                acc[propertyId] = {
                  parameter: propertyId,
                  output_range_optimal: `(${getValue(
                    (modelConfigDataCurrentStage?.output_range_optimal ?? modelConfigDataCurrentStage?.properties)?.[propertyId]?.min
                  )} - ${getValue(
                    (modelConfigDataCurrentStage?.output_range_optimal ?? modelConfigDataCurrentStage?.properties)?.[propertyId]?.max
                  )})`,
                  min: convertValue(min) || '',
                  max: convertValue(max) || '',
                  checked: false,
                  modelType: optimization_type,
                  value: optimization_type === 'range' ? '' : optimization_type,
                  priority: priority || 1
                }
              }
              return acc
            }, {})
          }, [intermediate_objectives, modelConfigData, dispatch, is_multistage, getValue, convertValue])

          const sendDataForPrediction = useCallback(() => {
            const { startStageIndex, endStageIndex } = findStageDetails()
            dispatch(clearInverseData())
            dispatch(setInverseData({
              start_stage: startStageIndex + 1,
              end_stage: endStageIndex + 1,
              objectives
            }))

            push(`/ai-engine/predict/formulation_prediction?version=${version}`)
          }, [dispatch, objectives, push])

          if (!version) return <Alert type="error" message={`${t('common.model')} ${t('common.notFound')}`} banner />

          return (
            <div>
              <h3>{`${t('aiEngine.tab.formulation_prediction')} ${t('common.Datavalidation')}:`}</h3>
              <p>
                <strong>{`${t('common.model')}:`}</strong> <Tag>{modelConfigData?.[0]?.objective}</Tag>
              </p>
              <p>
                <strong>{`${t('aiEngine.multiStage')}:`}</strong> <Tag>{is_multistage ? t('common.Yes') : t('common.no')}</Tag>
              </p>
              <h4>{`${t('common.objectives')}:`}</h4>
              <ObjectiveTable objectives={objectives} endStageIndex={findStageDetails().endStageIndex} priority_list={priority_list} />
              <Flex gap={16} style={{ marginTop: 16, marginBottom: 16 }} vertical>
                <Typography.Text strong>{t('aiAssistant.gotoConstraintsSetting.description')}</Typography.Text>
                {Object.values(objectives || {}).length > 0 && (
                  <StyledButton
                    loading={newInverseModel.inverseStatus === AsyncStates.LOADING}
                    type="primary"
                    onClick={() => {
                      sendDataForPrediction()
                    }}
                    style={{ outline: 'none' }}
                  >
                    {t('aiAssistant.gotoConstraintsSetting.title')}
                  </StyledButton>
                )}
              </Flex>
            </div>
          )
        }
      })
    }
  }
}

const ObjectiveTable = ({
  objectives,
  endStageIndex,
  priority_list
}: {
  objectives: any
  endStageIndex: number
  priority_list: Record<string, number>
}) => {
  const { modelConfigDataAiAssistant: modelConfigData } = useSelector((state: any) => state.formulate)

  const modelConfigDataCurrentStage = modelConfigData[endStageIndex] || {}

  const findPropertyName = (propertyId: string) => {
    const properties = modelConfigDataCurrentStage?.display_names?.properties || {}

    return properties[propertyId] || propertyId
  }

  const columns = [
    {
      title: 'Objective',
      dataIndex: 'objective',
      key: 'objective',
      render: (text: string, record: any) => (
        <Flex align="center" gap={8}>
          <Typography.Text strong>{findPropertyName(text)}</Typography.Text>
          {record.type === 'minimize' || record.type === 'maximize' ? (
            <Tag color={record.type === 'minimize' ? 'red' : 'green'}>{record.type.charAt(0).toUpperCase() + record.type.slice(1)}</Tag>
          ) : (
            <Tag color="blue">{record.value}</Tag>
          )}
        </Flex>
      )
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority'
    }
  ]

  const data = Object.values(objectives)
    .map((obj: any, index: number) => {
      const newObj = {
        objective: obj.parameter,
        type: obj.modelType,
        value: Array.isArray(obj?.val) ? obj.val.join(', ') : `${obj?.min} - ${obj?.max}`,
        priority: obj.priority,
        key: `${obj.parameter}`
      }
      return newObj
    })
    .flat()

  return (
    <Table
      columns={columns}
      dataSource={data}
      pagination={false}
      rowKey="key"
      size="small"
      style={{ marginTop: 16, marginBottom: 16 }}
      className="pretty-looking-table"
    />
  )
}
